import { render } from "./secJoin.vue?vue&type=template&id=228e6378&scoped=true"
import script from "./secJoin.vue?vue&type=script&lang=js"
export * from "./secJoin.vue?vue&type=script&lang=js"

import "./secJoin.vue?vue&type=style&index=0&id=228e6378&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228e6378"]])

export default __exports__